import React from "react";
import {
  Hero,
  OurStory,
  WelcomeToUs,
  WhyChooseUsList,
  OurProjects,
  Seo,
} from "../components";
import { PAGE_SEO } from "../common";

export const HomePage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.home} />
      <div className="page-bottom-spacing">
        <Hero />
        <WelcomeToUs />
        <OurProjects />
        <OurStory />
        <WhyChooseUsList />
      </div>
    </>
  );
};
